// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';
import NavigationDesktopBarItem, { type NavigationDesktopBarItemProps } from '../NavigationDesktopBarItem';
import UserBankroll from '../UserBankroll';

const Wrapper = styled.div`
  position: relative;

  width: 100%;
  display: flex;

  background-color: ${theme.DesktopNavigationBar.backgroundColor};

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  user-select: none;
  -webkit-tap-highlight-color: transparent;

  padding-left: 20px;
  padding-right: 12px;

  font-size: 0.8em;
`;

const Title = styled.div`
  font-size: 1.75em;
  font-weight: bold;
  color: ${theme.DesktopNavigationBarTitle.color};
  text-transform: uppercase;
  margin-right: min(20%, 5em);
  white-space: nowrap;
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  color: white;
`;

const StyledUserBankroll = styled(UserBankroll)`
  font-size: 1.9em;
`;
type Props = {
  className?: string;
  items: Array<NavigationDesktopBarItemProps>;
  bankrollFreebetValue?: number;
  bankrollRealValue?: number;
};

const NavigationDesktopBar = ({ className, items, bankrollFreebetValue = 0, bankrollRealValue = 0 }: Props) => {
  return (
    <Wrapper className={className}>
      <LeftColumn>
        <Title>{__('Sports bets')}</Title>
        {items.map(({ id, ...item }) => (
          <NavigationDesktopBarItem {...item} key={id} id={id} />
        ))}
      </LeftColumn>
      <RightColumn>
        <StyledUserBankroll bankrollFreebetValue={bankrollFreebetValue} bankrollRealValue={bankrollRealValue} />
      </RightColumn>
    </Wrapper>
  );
};
export default NavigationDesktopBar;
